<template>
  <div>
    <div class="subscription-plans">
      <div
          v-for="plan in allPlans"
          :key="plan.id"
          class="plan-switcher"
          :class="{'active': selectedPlan === plan.id}"
          @click.stop="onSelect(plan)"
      >
        <PlanItem
            :plan="plan"
            :price-type="priceType"
            :selected-plan="selectedPlan"
            :currency="currency"
            :is-ecommerce="isEcommerce"/>
      </div>
    </div>
  </div>
</template>
<script>
import PlanItem from "@/domain/events/components/PlanItem.vue";

export default {
  name: "BasePlanSwitcher",
  components: {PlanItem},
  emits: ['change'],
  props: {
    plans: {
      type: Array,
      required: true
    },
    trialPlan: {
      type: Object,
      required: false
    },
    plan: {
      type: Number,
      required: false
    },
    currency: {
      type: String,
      required: true
    },
    isEcommerce: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      selectedPlan: null,
      priceType: 'monthly'
    }
  },
  watch: {
    plans() {
      this.selectDefaultPlan()
    }
  },
  mounted() {
    this.selectDefaultPlan()
  },
  computed: {
    activePlan() {
      if (!this.selectedPlan)
        return this.plans[0]
      // If the selected plan is in the plans array, return it
      const plan = this.plans.find(plan => plan.id === this.selectedPlan)
      if (plan) return plan
      // If the selected plan is a trial plan, return the first plan in the plans array
      if (this.trialPlan && this.selectedPlan === this.trialPlan.id)
        return this.plans[0]
      return null
    },
    isSubscription() {
      return this.plans.some(plan => plan.is_subscription)
    },
    allPlans() {
      const plans = this.plans
      if (this.trialPlan) {
        plans.push(this.trialPlan)
      }
      return plans.sort((a, b) => (b.is_default ? 1 : 0) - (a.is_default ? 1 : 0))
    }
  },
  methods: {
    selectDefaultPlan() {
      this.selectedPlan = this.plan
      if (!this.selectedPlan)
        this.selectedPlan = this.plans.find(plan => plan.current)?.id
      if (!this.selectedPlan)
        this.selectedPlan = this.plans.find(plan => plan.is_default)?.id
      if (!this.selectedPlan)
        this.selectedPlan = this.plans[0].id

      this.$emit('change', this.selectedPlan)
    },
    async onSelect(plan) {
      this.selectedPlan = plan.id
      this.$emit('change', plan.id)
    }
  }
}
</script>
